/**
 * @generated SignedSource<<28a858602d1554af12f73a8ff471a918>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildMembersNonOrganizersSection_member$data = {
  readonly firstName: string;
  readonly lastName: string;
  readonly slugId: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  readonly " $fragmentType": "GuildMembersNonOrganizersSection_member";
};
export type GuildMembersNonOrganizersSection_member$key = {
  readonly " $data"?: GuildMembersNonOrganizersSection_member$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildMembersNonOrganizersSection_member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildMembersNonOrganizersSection_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhotoNew_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bc10829f1516b4ae355353a3271a1fdc";

export default node;
